import React, { useEffect, useState } from "react";
import { feesAPI, studentsAPI } from "../../services/api";


const initialFilters = {
    academicYear: "",
    curriculum: "",
    className: "",
    section: "",
    admissionNo: "",
    keyword: "",
};


const UpdateStudentFee = () => {

	const [studentData, setStudentData] = useState([]);
	const [allStudents, setAllStudents] = useState([]);
	const [loading, setLoading] = useState(false);
	const [academicYears, setAcademicYears] = useState([]);
	const [classes, setClasses] = useState([]);
	const [sections, setSections] = useState([]);
	const [filters, setFilters] = useState(initialFilters);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [selectedRows, setSelectedRows] = useState({});
	const [discounts, setDiscounts] = useState([]);
	const loadData = async () => {
    try {

        setLoading(true);

		const [
			studentRes,
			academicRes,
			classRes,
			sectionRes,
			discountRes
		] = await Promise.all([

			feesAPI.studentFees(),
			studentsAPI.academicYears(),
			studentsAPI.classes(),
			studentsAPI.sections(),
			feesAPI.discounts()

		]);

        const students = studentRes.data.results || studentRes.data;

        setStudentData(students);
        setAllStudents(students);

        setAcademicYears(academicRes.data.results || academicRes.data);
        setClasses(classRes.data.results || classRes.data);
        setSections(sectionRes.data.results || sectionRes.data);
        setDiscounts(discountRes.data.results || discountRes.data);

    } catch (err) {
        console.log(err);
    } finally {
        setLoading(false);
    }
};
	useEffect(() => {
		loadData();
	}, []);
    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const matchesFilters = (stu, keyword) => {
        if (filters.academicYear && stu.academicYear !== filters.academicYear) return false;
        if (filters.curriculum && stu.curriculum !== filters.curriculum) return false;
        if (filters.className && stu.className !== filters.className) return false;
        if (filters.section && stu.section !== filters.section) return false;

        if (filters.admissionNo &&
            !stu.admissionNo.toLowerCase().includes(filters.admissionNo.trim().toLowerCase())) {
            return false;
        }

        if (keyword) {
            const haystack = `${stu.studentName} ${stu.fatherName} ${stu.phone} ${stu.admissionNo}`.toLowerCase();
            if (!haystack.includes(keyword)) return false;
        }

        return true;
    };

	const handleSearch = async () => {

		try {

			const params = {
				academic_year: filters.academicYear,
				curriculum: filters.curriculum,
				class: filters.className,
				section: filters.section,
				admission_no: filters.admissionNo,
				keyword: filters.keyword,
			};

			const res = await feesAPI.searchStudentFees(params);

			const data = res.data.results || res.data;

			setStudentData(data);

			if (data.length === 1) {
				const stu = data[0];

				setFilters(prev => ({
					...prev,
					academicYear: stu.academicYearId || prev.academicYear,
					curriculum: stu.curriculum || "",
					className: stu.classId || prev.className,
					section: stu.sectionId || prev.section,
					admissionNo: stu.admissionNo || "",
					keyword: stu.studentName || ""
				}));
			}

		} catch (err) {

			console.log(err);

		}

	};

    const handleReset = () => {
        setFilters(initialFilters);
        setStudentData(allStudents);   
        setShowTable(false);
        setShowSuggestions(false);
    };
	const handleApply = async () => {
		try {
			const selectedStudents = studentData
				.filter(stu => selectedRows[stu.id])
				.map(stu => ({
					student_id: stu.id,
					fee_structure_id: stu.fee_structure_id,

					assigned_amount: stu.assigned_amount,
					class_discount: stu.discount_amount,
					final_amount: stu.final_amount,

					installments: stu.installments.map(term => ({
						installment_id: term.installment_id || term.installment || term.id,
						amount: term.amount,
						discount: Number(term.discount || 0)
					}))
				}));

			if (selectedStudents.length === 0) {
				alert("Please select at least one student.");
				return;
			}

			const payload = {
				students: selectedStudents
			};

			console.log("Apply Payload:", payload);

			// Save to Django
			await feesAPI.applyFee(payload);

			alert("Student Fee Updated Successfully");

			// Clear selected rows
			setSelectedRows({});

			// IMPORTANT:
			// Search again from database
			await handleSearch();

		} catch (err) {
			console.error("Apply Fee Error:", err);

			alert(
				err.response?.data?.message ||
				"Failed to update student fee."
			);
		}
	};
		const keywordSuggestions = allStudents.filter(stu =>

		`${stu.studentName}
		${stu.fatherName}
		${stu.phone}
		${stu.admissionNo}`

		.toLowerCase()

		.includes(filters.keyword.toLowerCase())

		);

	const selectSuggestion = (stu) => {

		setFilters({
			academicYear: stu.academicYearId || "",
			curriculum: stu.curriculum || "",
			className: stu.classId || "",
			section: stu.sectionId || "",
			admissionNo: stu.admissionNo || "",
			keyword: stu.studentName || ""
		});

		setStudentData([stu]);

		setShowSuggestions(false);
	};

    const toggleRow = (id) => {
        setSelectedRows((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    const isAllSelected = studentData.length > 0 && studentData.every((stu) => selectedRows[stu.id]);

    const toggleSelectAll = () => {
        const newValue = !isAllSelected;
        setSelectedRows((prev) => {
            const updated = { ...prev };
            studentData.forEach((stu) => {
                updated[stu.id] = newValue;
            });
            return updated;
        });
    };
const updateDiscount = (studentId, termId, value) => {

    const discount = Number(value) || 0;

    setStudentData(prev =>
        prev.map(student => {

            if (student.id !== studentId) return student;

            const installments = student.installments.map(term =>
                term.id === termId
                    ? { ...term, discount }
                    : term
            );

            const termDiscount = installments.reduce(
                (sum, t) => sum + (Number(t.discount) || 0),
                0
            );

            return {
                ...student,
                installments,
                term_discount: termDiscount,
                final_amount:
                    Number(student.assigned_amount) -
                    Number(student.discount_amount) -
                    termDiscount
            };
        })
    );
};
  return (
        <>
            <div className="page-header">
                <div><h2>Update Student Fee</h2></div>
            </div>

            <div className='card'>
                <div className='card-header d-inline'>
                    <div className='row'>
                        <div className='col-sm-4 col-lg-2 mb-2'>
                            <label className="form-label">
                                Select Academic Year
                            </label>
                            <select
                                className="form-select"
                                name="academicYear"
                                value={filters.academicYear}
                                onChange={handleFilterChange}
                            >
                                {
							academicYears.map(year=>(
							<option
							key={year.id}
							value={year.id}
							>
							{year.year}
							</option>
							))
							}
                            </select>
                        </div>

                        <div className='col-sm-4 col-lg-2 mb-2'>
                            <label className="form-label">
                                Curriculum
                            </label>
                            <select
                                className="form-select"
                                name="curriculum"
                                value={filters.curriculum}
                                onChange={handleFilterChange}
                            >
                                <option value="">--- Select ---</option>
                                <option value="SSC">SSC</option>
                                <option value="CBSE">CBSE</option>
                            </select>
                        </div>

                        <div className='col-sm-4 col-lg-2 mb-2'>
                            <label className="form-label">
                                Class
                            </label>
                            <select
                                className="form-select"
                                name="className"
                                value={filters.className}
                                onChange={handleFilterChange}
                            >
								{
								classes.map(cls=>(
								<option
								key={cls.id}
								value={cls.id}
								>
								{cls.name}
								</option>
								))
								}
                            </select>
                        </div>

                        <div className='col-sm-4 col-lg-2 mb-2'>
                            <label className="form-label">
                                Section
                            </label>
                            <select
                                className="form-select"
                                name="section"
                                value={filters.section}
                                onChange={handleFilterChange}
                            >
								{
								sections.map(sec=>(
								<option
								key={sec.id}
								value={sec.id}
								>
								{sec.name}
								</option>
								))
								}
                            </select>
                        </div>

                        <div className='col-sm-4 col-lg-2 mb-2'>
                            <label className="form-label">
                                Admission No
                            </label>

                            <input
                                type="text"
                                className="form-control"
                                name="admissionNo"
                                value={filters.admissionNo}
                                onChange={handleFilterChange}
                            />
                        </div>

                        <div className='col-sm-4 col-lg-2 mb-2 position-relative'>
                            <label className="form-label">
                                Search by key word
                            </label>

                            <input
                                type="text"
                                className="form-control"
                                name="keyword"
                                autoComplete="off"
                                value={filters.keyword}
                                onChange={(e) => {
                                    setFilters({ ...filters, keyword: e.target.value });
                                    setShowSuggestions(true);
                                }}
                                onFocus={() => setShowSuggestions(true)}
                            />

                            <div
                                style={{
                                    display: showSuggestions && filters.keyword.trim() ? "block" : "none",
                                    position: "absolute",
                                    background: "#fff",
                                    border: "1px solid #ccc",
                                    width: "100%",
                                    zIndex: 10,
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                }}
                            >
                                {keywordSuggestions.map((stu) => (
                                    <div
                                        key={stu.id}
                                        style={{ padding: "8px", cursor: "pointer" }}
                                        onMouseDown={() => selectSuggestion(stu)}
                                    >
                                        <b>{stu.studentName}</b><br />
                                        {stu.fatherName}, Ph:{stu.phone}
                                    </div>
                                ))}

                                {keywordSuggestions.length === 0 && (
                                    <div style={{ padding: "8px", color: "#999" }}>
                                        No matches
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className='col-sm-12 mt-3 mb-2 text-center gap-3'>
                            <button type="button" className='btn btn-primary me-3' onClick={handleSearch}>Search</button>
                            <button type="button" className='btn btn-outline-secondary' onClick={handleReset}>Reset</button>
                        </div>
                    </div>
                </div>


                 <div className='card-body'>
                    <div className='d-flex justify-content-between align-center'>
                        <h5 className='mt-2'>List Of Students</h5>

					<button
						className="btn-add"
						onClick={handleApply}
					>
						Apply
					</button>
                    </div>


                    <div className="table-responsive fee-table mb-0 border">
                        <table className="table fee-table align-middle mb-0 ">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Student Name</th>
                                    <th>
                                        <input
                                            type='checkbox'
                                            checked={isAllSelected}
                                            onChange={toggleSelectAll}
                                        /> &nbsp;
                                        Tution Fee
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {studentData.length === 0 && (
                                    <tr>
                                        <td colSpan={3} className="text-center py-4">
                                            No students found
                                        </td>
                                    </tr>
                                )}

                                {studentData.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>
                                            <div>{item.studentName}</div>
                                            <div>{item.fatherName}, Ph:{item.phone}</div>
                                        </td>
<td>

    <input
        type="checkbox"
        checked={!!selectedRows[item.id]}
        onChange={() => toggleRow(item.id)}
    />

    {(item.installments || []).map((term) => (
        <div
            key={term.id}
            className="d-flex justify-content-between align-items-center mb-2"
        >
            <div>
                <div><strong>{term.term}</strong></div>
                <div>₹{term.amount}</div>
            </div>

            <div>
                <input
                    type="number"
                    className="form-control"
                    style={{ width: "120px" }}
                    placeholder="Discount"
                    value={term.discount || ""}
                    onChange={(e) =>
                        updateDiscount(item.id, term.id, e.target.value)
                    }
                />
            </div>
        </div>
    ))}

    <hr />

    <div className="d-flex justify-content-between">
        <span><strong>Class wise Discount :</strong></span>
        <span>₹{item.discount_amount}</span>
    </div>

    <div className="d-flex justify-content-between">
        <span><strong>Assigned :</strong></span>
        <span>₹{item.assigned_amount}</span>
    </div>

    <div className="d-flex justify-content-between">
        <span><strong>Total Discount :</strong></span>
        <span>₹{item.discount_amount}</span>
    </div>

    <div className="d-flex justify-content-between">
        <span><strong>Final :</strong></span>
        <span>₹{item.final_amount}</span>
    </div>

</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </>
    )
}

export default UpdateStudentFee